import { Text } from '../../../../Components'
import { defineMessages, useIntl } from 'react-intl'

import styles from './FiltersHeader.module.scss'

export const MSG = defineMessages({
  heading: {
    id: 'HomeSearch.listings.filters.heading',
    defaultMessage: 'Filter Results'
  }
})

export const FiltersHeader = () => {
  const intl = useIntl()

  return (
    <Text
      size='xl'
      align='left'
      element='h1'
      weight='bold'
      variantCount='900'
      variant='neutralCool'
      className={styles.header}
    >
      {intl.formatMessage(MSG.heading)}
    </Text>
  )
}
